import styled from 'styled-components';

export const ForgetPasswordWrapper = styled.div`
 min-height: 100vh;
 display: flex;
 overflow: hidden;
 
  .ant-card-body {
    background-color: #ffffff !important;
  }

 .ant-input {
        background-color: #ffffff !important;
        border-color: #d9d9d9 !important;
        color: #000000d9 !important;
    }
    
`